module.exports = __webpack_public_path__ + "static/media/5.17217bd1.jpg";